import styled from 'styled-components'

import { theme } from '../../constants'

export const SegmentedGroup = styled.div`
  max-width: 100%;
  display: flex;
  gap: ${theme.spacing[1]};
  padding: ${theme.spacing[1]};
  overflow-x: auto;
  background: ${theme.colors.backgroundGrey};
  border: 1px solid ${theme.colors.border};
  border-radius: ${theme.radii.pill};
  scrollbar-width: none;

  &::-webkit-scrollbar {
    display: none;
  }
`

export const SegmentButton = styled.button<{ $active: boolean }>`
  min-height: ${theme.layout.controlHeight};
  padding: ${theme.spacing[2]} ${theme.spacing[3]};
  flex: 0 0 auto;
  color: ${({ $active }) =>
    $active ? theme.colors.black : theme.colors.textSecondary};
  background: ${({ $active }) =>
    $active ? theme.roleColors.student.main : 'transparent'};
  border: 0;
  border-radius: ${theme.radii.pill};
  box-shadow: ${({ $active }) =>
    $active ? theme.shadows.small : theme.shadows.none};
  font: inherit;
  font-size: ${theme.typography.size.caption};
  font-weight: ${theme.typography.weight.semibold};
  cursor: pointer;
  transition:
    color ${theme.motion.fast} ${theme.motion.easing},
    background ${theme.motion.fast} ${theme.motion.easing};

  &:hover {
    color: ${({ $active }) =>
      $active ? theme.colors.black : theme.colors.textPrimary};
  }

  &:focus-visible {
    outline: 3px solid ${theme.roleColors.student.focus};
    outline-offset: 1px;
  }

  @media (prefers-reduced-motion: reduce) {
    transition: none;
  }
`
